export default __webpack_public_path__ + "static/media/2020-constructie-1.06505f79.jpeg";